import React from 'react';
import NavBar from '../Components/NavBar';
import CaseStudyHead from '../Components/CaseStudyHead';
import Footer from '../Components/Footer';
import './ProjectDestails.css';

import tilionIcon from '../Assets/tilionIcon.svg';
import tilionMockup from '../Assets/mockupTilion.svg';

const ProjectDetails = () => {
  return (
    <>
      <NavBar />

      <CaseStudyHead
        topText="Tilion"
        bottomText="Case Study"
        className="details-head"
      />

      <section className="details-visuals">
        <img src={tilionIcon} alt="Tilion icon" className="details-icon" />
        <img src={tilionMockup} alt="Tilion mockup" className="details-mockup" />
      </section>

      <section className="details-overview">
        <h2 className="details-overview-title">Overview</h2>
        <p className="details-overview-text">
          Tilion is a social learning platform for kids. The product combines a
          mobile app, website, parent dashboard, and AR experience so children can
          learn together in a safe, playful environment.
        </p>
      </section>

      <section className="details-btns">
        <button type="button" className="details-btn">
          Branding
        </button>
        <button type="button" className="details-btn">
          Research
        </button>
        <button type="button" className="details-btn">
          Design Screens
        </button>
        <button type="button" className="details-btn">
          Prototype
        </button>
      </section>

      <Footer />
    </>
  );
};

export default ProjectDetails;
